
export const _GLOBALS = {
    DebugMode: process.env.DEBUG === "1" || false,
    BaseUrl: process.env.BASE_URL || "https://testah_walletconnector.aaflux.com/",
    SolanaRpc: process.env.SOLANA_RPC || 'https://muddy-powerful-shadow.solana-mainnet.quiknode.pro/b66f8a7f6fcec764bbaa387b2677d25ee99b5273',
    GoogleID: 'G-N3S7BKKRQM'
}

const imageSrc = `/images/icons/`;
export const _TOKENS = [
    {
        symbol: "EQUI",
        name: "EquiCoin (EQUI)",
        logo: imageSrc + "equi.svg",
        mint: "EquiC1doNqcCSVP1hserY6UKxthRwh2fan5iEBtdHhCE",
        usd_value: 0.15
    },
//    {
//        symbol: "TAXL",
//        name: "Tax Lien Token (TAXL)",
//        logo: imageSrc + "taxl.svg",
//        mint: "LienWchoScw6E8Godd4jbmXjnNLTLDwznYHiE8GcMWG",
//        usd_value: 1
//    },
//    {
//        symbol: "TAXD",
//        name: "Tax Deed Token (TAXD)",
//        logo: imageSrc + "taxd.svg",
//        mint: "DeedWQRvaULvRnSw5p1QJcfojuEq9bRqeJb5bGRPVW57",
//        usd_value: 1
//    }
];
export const _TOKENS_REFERRAL_PROGRAM = [
    {
        symbol: "EQUI",
        name: "EquiCoin (EQUI)",
        logo: imageSrc + "equi.svg",
        mint: "EquiC1doNqcCSVP1hserY6UKxthRwh2fan5iEBtdHhCE",
        usd_value: 0.15
    }
];

export const _ALLOWED_MINTS = [
  "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v", //USDC
  "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB", //USDT
// /* "EquiC1doNqcCSVP1hserY6UKxthRwh2fan5iEBtdHhCE", //EQUI
//  "LienWchoScw6E8Godd4jbmXjnNLTLDwznYHiE8GcMWG",  //TAXL
//  "DeedWQRvaULvRnSw5p1QJcfojuEq9bRqeJb5bGRPVW57"  //TAXD*/
//    "4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU" // USDC DEVNET
];